import React from 'react';
import styled from 'styled-components';
import { SearchIcon } from './icons/SearchIcon';
import { CloseIcon } from './icons/CloseIcon';

const ICON_SIZE = 24; // px
const ICON_PADDING = 16; // px

interface SearchBarProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchValue = "",
  onSearchChange = () => { },
  placeholder = 'Search',
  className,
  style,
}) => {
  return (
    <SearchBarContainer className={className} style={style}>
      <SearchInputWrapper>
        <SearchInput
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          autoComplete="off"
        />
        {searchValue ? (
          <IconButton
            type="button"
            aria-label="Clear search"
            onClick={() => onSearchChange('')}
          >
            <CloseIcon />
          </IconButton>
        ) : (
          <IconStatic>
            <SearchIcon fillColor="#B3B3B3" />
          </IconStatic>
        )}
      </SearchInputWrapper>
    </SearchBarContainer>
  );
};

const SearchBarContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    max-width: none;
    margin-bottom: 0;
  }

  @media (max-width: 480px) {
    margin-bottom: 0;
  }
`;

const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchInput = styled.input`
  width: 100%;
  height: 55px;
  border-radius: 8px;
  font-size: 16px;
  padding: 17px 16px;
  padding-right: ${ICON_SIZE + 20}px;
  border: 1px solid #cccccc;
  outline: none;
  background-color: #ffffff;
  box-sizing: border-box;

  &::placeholder {
    color: #999999;
  }

  &:focus {
    border-color: #0A2463;
  }

  @media (max-width: 768px) {
    height: 48px;
    font-size: 15px;
    padding: 14px 14px;
    padding-right: ${ICON_SIZE + 16}px;
    border-radius: 6px;
  }

  @media (max-width: 480px) {
    height: 44px;
    font-size: 14px;
    padding: 12px 12px;
    padding-right: ${ICON_SIZE + 12}px;
    border-radius: 4px;
  }
`;

const IconButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  height: ${ICON_SIZE}px;
  width: ${ICON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  z-index: 2;
`;

const IconStatic = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  height: ${ICON_SIZE}px;
  width: ${ICON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`; 